enum SIDEBAR_ACTION_TYPES {
	TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
}

export default SIDEBAR_ACTION_TYPES;
